import { Culture } from '../../types';

export const pimaMaricopa: Culture = {
  name: 'Pima Maricopa',
  languageFamily: 'Uto-Aztecan',
  terms: [
    {
      word: 'Akimel Oʼotham',
      phonetic: 'ah-kee-mel oh-oh-thahm',
      description: 'Name of the Pima people, meaning "River People."'
    },
    {
      word: 'Chumuth',
      phonetic: 'choo-muhth',
      description: 'Pima word for "earth" or "ground."'
    },
    {
      word: 'Keli Akimel',
      phonetic: 'keh-lee ah-kee-mel',
      description: 'Maricopa phrase meaning "Friendly River."'
    },
    {
      word: 'Piipaash',
      phonetic: 'pee-pahsh',
      description: 'Name of the Maricopa people in their language.'
    },
    {
      word: 'Shaʼchuk',
      phonetic: 'shah-chook',
      description: 'Word for "sun" in Pima.'
    }
  ]
};